module.exports = __webpack_public_path__ + "static/media/video-conference.2542d776.png";